import React from 'react';
import { BellFilled } from '@ant-design/icons';

/**
 * The 22px glowing red circle with a ringing white bell that marks due reminders (Tracked tab
 * icon, side menu). The bell's size and width are forced: inside an antd menu item every icon is
 * set to 14px with a 14px min-width, which enlarged it and then pushed it off center.
 */
export const RingingBellBadge: React.FC<{ className?: string; title?: string }> = ({
	className = '',
	title,
}) => (
	<span
		title={title}
		className={`box-border inline-flex h-[22px] w-[22px] shrink-0 animate-reminderGlow items-center justify-center rounded-full bg-character-danger ${className}`}
	>
		<BellFilled className="!flex !min-w-0 origin-top animate-bellRing !text-xs !text-white" />
	</span>
);
